import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import ReviewSubmissionContainer from "@/screens/Pricing/containers/ReviewSubmissionContainer"
import { reviewSubmissionSearchSchema } from "@/screens/Pricing/types/searchParams"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const Route = createFileRoute("/app/pricing/$priceChangeId/review")({
  component: () => (
    <PermissionContentWrapper
      permissions={[
        PermissionActionType.PRICING_VIEW,
        PermissionActionType.PRICING_MANAGER,
        PermissionActionType.PRICING_MAINTENANCE,
      ]}
    >
      <ReviewSubmissionContainer />
    </PermissionContentWrapper>
  ),
  validateSearch: zodValidator(reviewSubmissionSearchSchema),
  loader: async (): Promise<void> => {
    await useUnitOfMeasurementsStore.getState().getUnits()
  },
})
